import { TableHeaderConfig } from 'types/table/TableHeaderConfig.type';
import style from '../../../../pages/intermediary/intermediary.module.scss';
import clsx from 'clsx';

interface ClientColumns {
  clientName: string;
  clientSurname: string;
  investmentType: string;
}

export const clientTableHeaderData: TableHeaderConfig<ClientColumns>[] = [
  {
    key: 'clientName',
    label: 'Client First Name',
    className: style.headers
  },
  {
    key: 'clientSurname',
    label: 'Client Surname',
    className: style.headers
  },
  {
    key: 'investmentType',
    label: 'Investment Type',
    className: style.headers
  },
  {
    label: '',
    className: clsx(style.headers, style.smallHeader)
  }
];
